import { render, staticRenderFns } from "./JImportModal.vue?vue&type=template&id=495e2a21&scoped=true"
import script from "./JImportModal.vue?vue&type=script&lang=js"
export * from "./JImportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495e2a21",
  null
  
)

export default component.exports